import { Quote } from "lucide-react";

export const TestimonialCard = ({ quote, name, role, initials, accent = "#1677C8", testId }) => (
  <figure className="card-soft p-8 md:p-10 h-full flex flex-col gap-6" data-testid={testId}>
    <Quote size={30} className="text-[#FFD45C]" strokeWidth={2.5} aria-hidden="true" />
    <blockquote className="text-base md:text-lg text-[#14324A] leading-relaxed">
      “{quote}”
    </blockquote>
    <figcaption className="flex items-center gap-3 mt-auto">
      <div
        className="w-11 h-11 rounded-full inline-flex items-center justify-center font-display font-bold text-white"
        style={{ backgroundColor: accent }}
        aria-hidden="true"
      >
        {initials}
      </div>
      <div>
        <div className="font-semibold text-[#14324A]">{name}</div>
        <div className="text-xs text-[#4B6B86]">{role}</div>
      </div>
    </figcaption>
  </figure>
);

export default TestimonialCard;
